import { createReducer, on } from '@ngrx/store';

import { FollowersActions } from './followers.actions';
import { FollowersState } from './followers.model';

export const initialState: FollowersState = {
  entityType: null,
  entityId: null,
  followers: [],
  isLoading: false,
};

export const followersReducer = createReducer(
  initialState,

  on(
    FollowersActions.init,
    (state, { entityType, entityId }): FollowersState => ({
      ...state,
      entityType,
      entityId,
      isLoading: true,
    })
  ),

  on(
    FollowersActions.getFollowers,
    (state): FollowersState => ({
      ...state,
      isLoading: true,
    })
  ),

  on(
    FollowersActions.getFollowersSuccess,
    (state, { followers }): FollowersState => ({
      ...state,
      followers,
      isLoading: false,
    })
  ),

  on(
    FollowersActions.getFollowersFailure,
    (state): FollowersState => ({
      ...state,
      isLoading: false,
    })
  ),

  on(
    FollowersActions.addFollowers,
    (state): FollowersState => ({
      ...state,
      isLoading: true,
    })
  ),

  on(
    FollowersActions.addFollowersSuccess,
    (state, { followers }): FollowersState => ({
      ...state,
      followers,
      isLoading: false,
    })
  ),

  on(
    FollowersActions.addFollowersFailure,
    (state): FollowersState => ({
      ...state,
      isLoading: false,
    })
  ),

  on(
    FollowersActions.removeFollower,
    (state): FollowersState => ({
      ...state,
      isLoading: true,
    })
  ),

  on(
    FollowersActions.removeFollowerSuccess,
    (state, { followers }): FollowersState => ({
      ...state,
      followers,
      isLoading: false,
    })
  ),

  on(
    FollowersActions.removeFollowerFailure,
    (state): FollowersState => ({
      ...state,
      isLoading: false,
    })
  )
);
